// src/pages/ServicePartnerEditPage.jsx
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ServicePartnerForm from "../components/servicepartner/ServicePartnerForm";
import axios from "axios";

export default function ServicePartnerEditPage() {
  const { id } = useParams();
  const [partner, setPartner] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/service-partner/${id}`)
      .then((res) => setPartner(res.data))
      .catch((err) => console.error("Fehler beim Laden des Service Partners:", err));
  }, [id]);

  if (!partner) return <p>Lade Service Partner-Daten …</p>;

  return <ServicePartnerForm existingPartner={partner} />;
}